class LocalStore {
  private readonly APP_NAME = 'datashop-patientSidebar';

  private isSupported(): boolean {
    // Sometimes browsers block the access to LocalStorage, like while browsing in private mode and so on...
    // So wrapping storage accessing code in try/catch because an exception will be thrown in such cases
    try {
      const testKey = '__some_random_key_you_are_not_going_to_use__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  private getKey = (key: string): string => `${this.APP_NAME}.${key}`;

  public setItem<T>(key: string, value: T): void {
    if (this.isSupported()) {
      const stringVal = JSON.stringify(value);
      localStorage.setItem(this.getKey(key), stringVal);
    }
  }

  public getItem<T>(key: string): T | null {
    if (this.isSupported()) {
      const val = localStorage.getItem(this.getKey(key));
      return val !== null ? JSON.parse(val) : null;
    }

    return null;
  }

  public removeItem(key: string): void {
    if (this.isSupported()) {
      localStorage.removeItem(this.getKey(key));
    }
  }
}

export const localStore = new LocalStore();
